import { render, staticRenderFns } from "./LanguageEntry.vue?vue&type=template&id=f5291d9e&"
import script from "./LanguageEntry.vue?vue&type=script&lang=js&"
export * from "./LanguageEntry.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports